/**
 * @generated SignedSource<<4b184f0626fe423a03bad39ce69e8704>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChatThreadUsers_Query$variables = {
  threadId: string;
};
export type ChatThreadUsers_Query$data = {
  readonly thread: {
    readonly " $fragmentSpreads": FragmentRefs<"ChatThreadUsers_Thread">;
  } | null | undefined;
};
export type ChatThreadUsers_Query = {
  response: ChatThreadUsers_Query$data;
  variables: ChatThreadUsers_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "threadId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "threadId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = [
  (v3/*: any*/),
  (v4/*: any*/)
],
v6 = [
  (v3/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "ChatThread",
  "kind": "LinkedField",
  "name": "directChatThread",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChatThreadUsers_Query",
    "selections": [
      {
        "alias": "thread",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ChatThreadUsers_Thread"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChatThreadUsers_Query",
    "selections": [
      {
        "alias": "thread",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "joined",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "threadType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "purpose",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "muted",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "recipient",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v5/*: any*/),
                    "type": "User",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v5/*: any*/),
                    "type": "ChatBot",
                    "abstractKey": null
                  },
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isRecipient"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v6/*: any*/),
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "users",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ChatContact",
                            "kind": "LinkedField",
                            "name": "chatContact",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "description",
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "self",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastSeenAt",
                            "storageKey": null
                          }
                        ],
                        "type": "User",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/)
                        ],
                        "type": "ChatBot",
                        "abstractKey": null
                      }
                    ],
                    "type": "Recipient",
                    "abstractKey": "__isRecipient"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              (v8/*: any*/)
            ],
            "type": "ChatThread",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7fd21e4ce81c77c082e8b51cd2ab5118",
    "id": null,
    "metadata": {},
    "name": "ChatThreadUsers_Query",
    "operationKind": "query",
    "text": "query ChatThreadUsers_Query(\n  $threadId: ID!\n) {\n  thread: node(id: $threadId) {\n    __typename\n    ...ChatThreadUsers_Thread\n    id\n  }\n}\n\nfragment ChatThreadEditDialog_Recipient on Recipient {\n  __isRecipient: __typename\n  ... on User {\n    id\n    name\n  }\n  ... on ChatBot {\n    id\n    name\n  }\n}\n\nfragment ChatThreadEditDialog_Thread on ChatThread {\n  id\n  title\n  avatarUrl\n  purpose\n  recipient {\n    __typename\n    ...ChatThreadEditDialog_Recipient\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  users {\n    id\n  }\n}\n\nfragment ChatThreadUsers_Thread on ChatThread {\n  id\n  joined\n  threadType\n  purpose\n  muted\n  recipient {\n    __typename\n    ... on User {\n      id\n    }\n    ... on ChatBot {\n      id\n    }\n    ...ChatThreadEditDialog_Recipient\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  users {\n    id\n    ...Contact_Contact\n  }\n  ...ChatThreadEditDialog_Thread\n}\n\nfragment Contact_Contact on Recipient {\n  __isRecipient: __typename\n  ... on User {\n    id\n    name\n    directChatThread {\n      id\n    }\n  }\n  ... on ChatBot {\n    id\n    name\n    directChatThread {\n      id\n    }\n  }\n  ...RecipientAvatar_Recipient\n  ...chat_useContactDescription\n}\n\nfragment RecipientAvatar_Recipient on Recipient {\n  __isRecipient: __typename\n  __typename\n  ... on User {\n    ...UserAvatarContainer_User\n  }\n  ... on ChatBot {\n    name\n    avatarUrl\n  }\n}\n\nfragment UserAvatarContainer_User on User {\n  id\n}\n\nfragment chat_useContactDescription on Recipient {\n  __isRecipient: __typename\n  __typename\n  ... on User {\n    chatContact {\n      description\n      id\n    }\n  }\n  ...chat_useOnlineStatus\n}\n\nfragment chat_useOnlineStatus on Recipient {\n  __isRecipient: __typename\n  __typename\n  ... on User {\n    self\n    lastSeenAt\n  }\n  ... on ChatBot {\n    __typename\n  }\n}\n"
  }
};
})();

(node as any).hash = "126d97271ae3d5d3cc28d9b397b99fff";

export default node;
